import type { NavItem } from './PortalLayout'

/** Whether the path is this item's page: exactly for `end` items, otherwise the item or anything under it, plus its `also` pages. */
export function matchesPath(item: NavItem, pathname: string): boolean {
  if (item.also?.test(pathname)) return true
  return item.end ? pathname === item.to : pathname === item.to || pathname.startsWith(`${item.to}/`)
}

/** Every item with its sub-items after it, for lookups that do not care about the tree. */
export function flattenNav(nav: NavItem[]): NavItem[] {
  return nav.flatMap((item) => [item, ...(item.children ?? [])])
}

/**
 * The item that names the current page in the top bar: the most specific
 * match, so /admin/products/options reads "Product Options" rather than the
 * Products group it sits under. A child listed after its parent wins a tie.
 */
export function activeNavItem(nav: NavItem[], pathname: string): NavItem | undefined {
  let best: NavItem | undefined
  for (const item of flattenNav(nav)) {
    if (matchesPath(item, pathname) && (!best || item.to.length >= best.to.length)) best = item
  }
  return best
}
